import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const DeleteModal = ({show, handleClose, project, onDelete}) => {
  return (
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure want to delete!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => onDelete(project.id)}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
  )
}

export default DeleteModal